<template>
  <b-table
    class="sticky-table-header is-in-modal"
    :data="products"
    narrowed
    hoverable
  >
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <b-table-column
      field="name"
      :label="$t('bags.product')"
      sortable
      v-slot="props"
    >
      {{ props.row.name }}
    </b-table-column>

    <b-table-column
      field="ean"
      :label="$t('bags.barcode')"
      sortable
      v-slot="props"
    >
      {{ props.row.barcode }}
    </b-table-column>

    <b-table-column
      field="price"
      :label="$t('bags.price')"
      sortable
      v-slot="props"
    >
      {{ `${currencySymbol} ${formatMoney(props.row.price)}` }}
    </b-table-column>

    <!-- <b-table-column :label="$t('bags.edit')" v-slot="props">
      <button class="button is-small" @click="editBag(props.row)">
        <b-icon icon="edit" type="is-dark"></b-icon>
      </button>
    </b-table-column> -->

    <template slot="empty">
      <section class="section">
        <div class="content has-text-grey has-text-centered">
          <p>
            <b-icon icon="sad-cry" size="is-large"></b-icon>
          </p>
          <p>{{ $t("common.tableEmptyMessage") }}</p>
        </div>
      </section>
    </template>
  </b-table>
</template>

<script>
import { mask } from "../../mixins/mask";
import { common } from "../../mixins/common";

export default {
  props: ["products", "currencySymbol"],

  mixins: [common, mask],

  data() {
    return {
      isLoading: false
    };
  },

  methods: {
    editBag(bag) {
      this.$emit("edit-bag", bag);
    }
  }
};
</script>
